'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PaperPlane = require('./PaperPlane');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PaperPlane).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/PaperPlane/index.js
// module id = 1246
// module chunks = 1